import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import itemgroupModule from './itemgroup'
import warehouseModule from './warehouse'
import accountHeadModule from './accountHead'
import billSundryModule from './billSundary'
import userModule from './user'
import accountMasterModule from './accountMaster'
import itemMasterModule from './itemMaster'
import fiscalYearMasterModule from './fiscalYearMaster'
import purchase from './purchase'
import sales from './sales'
import accounting from './accounting'
import accountingReport from './accountingReport'
import inventoryReport from './inventoryReport'
import admin from './admin'
import globalReport from './globalReport'
import pos from './pos'
import humanResource from './humanResource'
import analysisReport from './analysisReport'
import fixedAssets from './fixedAssets'
import fixedAssetsPurchase from './fixedAssetsPurchase'
import fixedAssetsSales from './fixedAssetsSales'
import eventManagement from './eventManagement'
import crm from './crm'
import finalYearSettlement from './finalYearSettlement'
import website from './website'
import costCenter from './costCenter'
import graph from './graph'
Vue.use(Vuex)
export default new Vuex.Store({
  state,
  actions,
  mutations,
  getters,
  modules: {
    itemgroup: itemgroupModule,
    accountHead: accountHeadModule,
    warehouse: warehouseModule,
    billSundary: billSundryModule,
    users: userModule,
    accountMaster: accountMasterModule,
    itemMaster: itemMasterModule,
    fiscalYearMaster: fiscalYearMasterModule,
    purchase: purchase,
    sales: sales,
    accounting: accounting,
    accountingReport: accountingReport,
    inventoryReport: inventoryReport,
    admin: admin,
    globalReport: globalReport,
    pos: pos,
    hr: humanResource,
    analysisReport: analysisReport,
    fixedAssets: fixedAssets,
    fixedAssetsPurchase: fixedAssetsPurchase,
    fixedAssetsSales: fixedAssetsSales,
    eventManagement: eventManagement,
    crm: crm,
    finalYearSettlement: finalYearSettlement,
    website: website,
    costCenter: costCenter,
    graph: graph
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js